module.exports = __webpack_public_path__ + "img/dataport-logo.6e654a7e.svg";